import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";
import { toast } from "sonner";

export const useFavoriteEvents = () => {
  const { user } = useAuth();
  const [favoriteIds, setFavoriteIds] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      fetchFavorites();
    } else {
      setFavoriteIds(new Set());
    }
  }, [user]);

  const fetchFavorites = async () => {
    if (!user) return;
    
    const { data, error } = await supabase
      .from("favorite_events")
      .select("event_id")
      .eq("user_id", user.id);

    if (!error && data) {
      setFavoriteIds(new Set(data.map(f => f.event_id)));
    }
  };

  const toggleFavorite = async (eventId: string, isRTL: boolean = false) => {
    if (!user) {
      toast.error(isRTL ? "يجب تسجيل الدخول أولاً" : "Please login first");
      return false;
    }

    setLoading(true);
    const isFavorite = favoriteIds.has(eventId);

    if (isFavorite) {
      const { error } = await supabase
        .from("favorite_events")
        .delete()
        .eq("user_id", user.id)
        .eq("event_id", eventId);

      if (error) {
        toast.error(isRTL ? "حدث خطأ" : "An error occurred");
      } else {
        setFavoriteIds(prev => {
          const next = new Set(prev);
          next.delete(eventId);
          return next;
        });
        toast.success(isRTL ? "تمت الإزالة من المفضلة" : "Removed from favorites");
      }
    } else {
      const { error } = await supabase
        .from("favorite_events")
        .insert({ user_id: user.id, event_id: eventId });

      if (error) {
        toast.error(isRTL ? "حدث خطأ" : "An error occurred");
      } else {
        setFavoriteIds(prev => new Set(prev).add(eventId));
        toast.success(isRTL ? "تمت الإضافة للمفضلة" : "Added to favorites");
      }
    }

    setLoading(false);
    return true;
  };

  const isFavorite = (eventId: string) => favoriteIds.has(eventId);

  return { favoriteIds, toggleFavorite, isFavorite, loading };
};
